import SiafLiteApiRepository from "../../external/siafLiteApi";

class TiposItemService {
  constructor() {
    this.urlBase = "/estoque/tipos-item";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }
}

export default TiposItemService;
